import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@nextui-org/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faBuilding, faUsers, faChevronDown } from "@fortawesome/free-solid-svg-icons";

const list = [
  {
    id: 1,
    name: "Create a new organization",
    description: "Start fresh with a new ESG workspace",
    icon: faBuilding,
  },
  {
    id: 2,
    name: "Join an existing organization",
    description: "Collaborate with an existing team",
    icon: faUsers,
  },
];

const CreateOrgButtton = () => {
  const navigate = useNavigate();
  return (
    <Dropdown placement="bottom-end">
      <DropdownTrigger>
        <Button 
          color="primary" 
          size="sm"
          className="bg-primary-600 hover:bg-primary-700 text-white px-4 font-medium"
          startContent={<FontAwesomeIcon icon={faPlus} className="text-white text-xs" />}
          endContent={<FontAwesomeIcon icon={faChevronDown} className="text-white text-xs" />}
        >
          Create Organization
        </Button>
      </DropdownTrigger>
      <DropdownMenu aria-label="Organization Actions" className='w-[320px]'>
        <DropdownItem 
          key="create" 
          href='/org-list/create' 
          variant='flat' 
          description="Start fresh with a new ESG workspace"
          startContent={<FontAwesomeIcon icon={faBuilding} className="text-primary-600" />}
          className="py-3"
        >
          Create a new organization
        </DropdownItem>
        <DropdownItem 
          key="join" 
          href='/join-space' 
          variant='flat' 
          description="Collaborate with an existing team"
          startContent={<FontAwesomeIcon icon={faUsers} className="text-primary-600" />}
          className="py-3"
        >
          Join an existing organization
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default CreateOrgButtton;
